module.exports = __webpack_public_path__ + "img/co2.6b62f23d.png";